export default __webpack_public_path__ + "eaece5b174c3fd38a75220444c81dbc3.png";